import { LinkProps } from '@procore/core-react/dist/_typedoc/Link/Link.types.json';
import * as React from 'react';
export default {
  LinkProps,
  React
};